import { HealthCareService } from '@saas/interfaces/graphql'
// @ts-expect-error TS(2306)
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { ReactNode, createContext, useContext, useEffect, useState } from 'react'
import { CircularProgress, Typography } from '@mui/material'
import useCurrentHcs from '../../hooks/useCurrentHcs'
import RouterOutsideContainer from '../../routers/RouterOutsideContainer'

export const LegacyHcsContext = createContext<HealthCareService | null>(null)

export const useLegacyHcs = () => {
    const legacyHcs = useContext(LegacyHcsContext)
    if (!legacyHcs) throw new Error('[useLegacyHcs] legacyHcs is not defined!')
    return legacyHcs
}

export const LegacyHcsProvider = ({ children }: { children: ReactNode }) => {
    const [legacyHcs, setLegacyHcs] = useState<HealthCareService | null>(null)
    const { id } = useCurrentHcs()
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        const fetchLegacyHcs = async () => {
            setIsLoading(true)
            const hcs = await ToktokdocLib.HealthCareService.findOne(id, [
                'address',
                'sector',
                'type',
                'payModel',
                'preferences',
                'synchroService',
            ])
            const fullAddress = await hcs.getAdministrativeAddress()
            setLegacyHcs({ ...hcs.toJSON(), fullAddress })
            setIsLoading(false)
        }

        fetchLegacyHcs()
    }, [id])

    if (isLoading || !legacyHcs)
        return (
            <RouterOutsideContainer>
                <CircularProgress size="3.6rem" />
            </RouterOutsideContainer>
        )

    return <LegacyHcsContext.Provider value={legacyHcs}>{children}</LegacyHcsContext.Provider>
}
